export const getMonthArray = arr => {
    return arr.map(item => item.month)
}
export const getLineValuesArray = arr => {
    return arr.map(item => parseInt(item.amount))
}